import {AbstractApi} from '@/service/api/AbstractApi'
import {I18n} from 'vue-i18n'
import {AuthenticationService} from '@/service/authentication/AuthenticationService'
import {SiteManagerDashboardBean} from '@/service/model/sitemanager/SiteManagerDashboardBean'

export class SiteManagerDashboardApi extends AbstractApi {
  constructor(i18n: I18n, authenticationService: AuthenticationService) {
    super(i18n, authenticationService)
  }

  async fetchDashboard(): Promise<SiteManagerDashboardBean> {
    return this.get({
      path: '/api/mp/v2/site-customer/dashboard',
      authentication: 'required',
    })
  }
}
